<template>
  <div class="list-item" :class="classFromColorIndex(colorIndex, 'border-primary','border-secondary')">
    <div class="left-content">
      <div class="me-3">
        <slot name="icon" />
      </div>
      <div class="main-info">
        <a :href="actionUrl" target="_blank">
          <h3 class="title" :class="classFromColorIndex(colorIndex, 'text-primary','text-secondary')">{{ displayTitle }}</h3>
        </a>
        <div class="text-content">
          <slot name="content" />
        </div>
        <div class="button-area mt20">
          <ActionButton :action-url="actionUrl" :color-index="colorIndex">
            <template #action-button-text>
              <slot name="action-button-text" />
            </template>
          </ActionButton>
        </div>
      </div>
    </div>
    <div class="right-content">
      <a v-if="imageUrl" class="btn-link" role="button" :href="actionUrl">
        <img class="event-image" :src="imageUrl">
      </a>

      <div class="description-learn-more">
        <div class="description">
          {{ description }}
        </div>
        <a class="btn-link" role="button" :href="actionUrl">
          <div>{{ i18n.t('public.events.learn_more') }}</div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { listItemMixin } from './list-item-mixin'

export default {
  mixins: [ listItemMixin ],

  props: {
    description: {
      type: String,
      required: false,
      default: ''
    },
    // the imageUrl can be null when the event does not have an image.
    imageUrl: {
      type: String,
      required: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.list-item {
  display: flex;
  justify-content: space-between;
  min-height: 250px;
  background-color: #ECECEC;
}

.left-content {
  display: flex;
  padding: 20px;
  flex: 1
}

.main-info {
  flex: 1
}

.text-content {
  font-size: 15px;
  margin-top: 10px;
}

.button-area {
  flex-basis: 150px;
}

.title {
  margin-top: 10px;
  margin-bottom: 0;
}

.right-content {
  background-color: #DEDEDE;
  flex: 0 0 220px;
  display: none;

  @include breakpoints.screen-lg-up {
    display: block;
  }

  .action-button {
    margin: 20px 0 0 0;
  }

  .event-image {
    max-height: 140px;
  }

  .description-learn-more {
    padding: 10px;
  }

  .description {
    width: 100%;
    line-height: 1.4em;
    height: 4.2em;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow-wrap: anywhere;
    word-break: normal;
  }
}
</style>
